import React, {Component} from 'react';
import {connect} from 'react-redux';
import $ from 'jquery';

class NavBarShoppingCartIcon extends Component {

    componentDidMount() {
        $('.cont-cart').hide();
    }

    refresh = () => {
        const {shoppingCartReducer} = this.props;

        setTimeout(() => {
            if (shoppingCartReducer.items.length === 0) {
                $('.cont-cart').hide();
            } else {
                $('.cont-cart').show();
            }
        }, 50);
    }

    render() {
        const {shoppingCartReducer, configReducer: { history }, icon, iconColor, textColor} = this.props;
        return (
            <i className={icon + " fa-lg"} style={{ color: iconColor, fontSize: 30,paddingTop:20}}
               onClick={() => history.goShoppingCart()}>&nbsp;&nbsp;
                <span className="cont-cart" style={{color: textColor}}>{shoppingCartReducer.items.length}</span>{this.refresh()}
            </i>
        );
    }
}

const mapStateToProps = store => {
    return {
        configReducer: store.ConfigReducer,
        shoppingCartReducer: store.ShoppingCartReducer,
    };
};

const mapDispatchToProps = dispatch => {
    return {};
};

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(NavBarShoppingCartIcon)

